import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppStore } from "@hooks/useAppStore";
import { useAppTheme } from "@hooks/useAppTheme";
import Box from "@memorang/ui/components/Box";
import Button from "@memorang/ui/components/Button";
import DialogWrapper from "@memorang/ui/components/DialogWrapper";
import type { IconType } from "@memorang/ui/icon";
import { useDevice } from "@memorang/ui/useDevice";
/* -----------------UI--------------- */
import { Dialog, Text } from "react-native-paper";
/* -----------------Props--------------- */
type Props = {
	open: boolean;
	handleClose: () => void;
	title: string;
	description: string;
	cta: string;
};

const ConfidenceListItem = ({
	variant,
}: {
	variant: "high" | "medium" | "low";
}) => {
	const theme = useAppTheme();
	const icons: Record<string, IconType> = {
		high: "emoticon-happy-outline",
		medium: "emoticon-neutral-outline",
		low: "emoticon-sad-outline",
	};
	const appFont = useAppStore((store) => store.app.font) || "opensans";
	return (
		<Box display="flex" flexDirection="row" alignItems="center" marginTop={16}>
			<Box
				height={48}
				backgroundColor={theme.colors.confidence[variant]}
				width={88}
				display="flex"
				flexDirection="row"
				alignItems="center"
				justifyContent="center"
				borderRadius={24}
				marginRight={16}
			>
				<Icon name={icons[variant]} color={theme.colors.white} size={30} />
			</Box>
			<Text allowFontScaling={false} style={{ fontSize: 16 }}>
				<Text
					variant="bodyMedium"
					style={{
						textTransform: "capitalize",
						fontFamily: `${appFont}-semibold`,
					}}
				>
					{variant}
				</Text>{" "}
				confidence
			</Text>
		</Box>
	);
};
/* -----------------Component--------------- */
const TutorialDialog = (props: Props) => {
	const { open, handleClose, title, description, cta } = props;

	const { isMobile } = useDevice();

	const confidenceLevels = ["high", "medium", "low"] as const;
	return (
		<DialogWrapper
			visible={open}
			handleClose={handleClose}
			maxWidth={"xs"}
			width={isMobile ? "80%" : 380}
		>
			<Dialog.Icon icon="emoticon-happy-outline" />
			<Dialog.Title
				allowFontScaling={false}
				style={{
					textAlign: "center",
				}}
			>
				{title}
			</Dialog.Title>
			<Dialog.Content>
				<Box gap={8}>
					<Text variant="bodyMedium" allowFontScaling={false}>
						{description}
					</Text>
					<Box gap={8}>
						{confidenceLevels.map((variant) => (
							<ConfidenceListItem key={variant} variant={variant} />
						))}
					</Box>
				</Box>
			</Dialog.Content>
			<Dialog.Actions>
				<Button onPress={handleClose}>{cta}</Button>
			</Dialog.Actions>
		</DialogWrapper>
	);
};

export default TutorialDialog;
